(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lost-scenarios"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSection(section) {
    if (!section || section.dataset.lsInit === 'true') return;
    section.dataset.lsInit = 'true';

    var items = section.querySelectorAll('.ls-item');
    var triggers = section.querySelectorAll('.ls-trigger');
    var stages = section.querySelectorAll('.ls-product-stage');
    var watchButtons = section.querySelectorAll('.ls-watch');
    var modal = section.querySelector('[data-ls-modal]');
    var modalVideoWraps = section.querySelectorAll('.ls-modal-video-wrap');
    var modalVideos = section.querySelectorAll('.ls-modal-video');
    var closeButton = section.querySelector('[data-ls-close-modal]');
    var lastTriggerButton = null;

    function setActive(scenario) {
      items.forEach(function (item) {
        var isOpen = item.dataset.scenario === scenario;
        item.classList.toggle('is-open', isOpen);
        var trigger = item.querySelector('.ls-trigger');
        if (trigger) {
          trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        }
      });
      stages.forEach(function (stage) {
        var isActive = stage.dataset.scenario === scenario;
        stage.classList.toggle('is-active', isActive);
        if (isActive) {
          stage.removeAttribute('hidden');
        } else {
          stage.setAttribute('hidden', '');
        }
      });

      // On mobile, smooth-scroll so the product image and active item are visible
      if (window.matchMedia('(max-width: 768px)').matches) {
        var product = section.querySelector('.ls-product');
        if (product) {
          var rect = product.getBoundingClientRect();
          var top = rect.top + window.pageYOffset - 80;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      }
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var scenario = trigger.dataset.scenario;
        var item = trigger.closest('.ls-item');
        // If clicking an already-open item, do nothing (always-one-open accordion)
        if (item && item.classList.contains('is-open')) return;
        setActive(scenario);
      });

      // Keyboard navigation between triggers
      trigger.addEventListener('keydown', function (e) {
        var currentIndex = Array.prototype.indexOf.call(triggers, trigger);
        var target = null;
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          target = triggers[(currentIndex + 1) % triggers.length];
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          target = triggers[(currentIndex - 1 + triggers.length) % triggers.length];
        } else if (e.key === 'Home') {
          e.preventDefault();
          target = triggers[0];
        } else if (e.key === 'End') {
          e.preventDefault();
          target = triggers[triggers.length - 1];
        }
        if (target) {
          target.focus();
        }
      });
    });

    if (modal && typeof modal.showModal === 'function') {
      function openModal(scenario, triggerEl) {
        lastTriggerButton = triggerEl || null;
        modalVideoWraps.forEach(function (wrap) {
          var isActive = wrap.dataset.scenario === scenario;
          if (isActive) {
            wrap.removeAttribute('hidden');
          } else {
            wrap.setAttribute('hidden', '');
          }
        });
        try { modal.showModal(); } catch (err) { modal.setAttribute('open', ''); }
        document.body.classList.add('ls-modal-open');
        modalVideoWraps.forEach(function (wrap) {
          if (wrap.dataset.scenario !== scenario) return;
          var video = wrap.querySelector('video');
          if (!video) return;
          try { video.currentTime = 0; } catch (err) { /* noop */ }
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () { /* autoplay blocked — controls visible */ });
          }
        });
      }

      function closeModal() {
        modalVideos.forEach(function (video) {
          try { video.pause(); video.currentTime = 0; } catch (err) { /* noop */ }
        });
        if (modal.open) { modal.close(); } else { modal.removeAttribute('open'); }
        document.body.classList.remove('ls-modal-open');
        if (lastTriggerButton && typeof lastTriggerButton.focus === 'function') {
          lastTriggerButton.focus();
        }
        lastTriggerButton = null;
      }

      watchButtons.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          openModal(btn.dataset.scenario, btn);
        });
      });

      if (closeButton) {
        closeButton.addEventListener('click', closeModal);
      }

      modal.addEventListener('click', function (e) {
        if (e.target === modal) closeModal();
      });

      modal.addEventListener('close', function () {
        modalVideos.forEach(function (video) {
          try { video.pause(); video.currentTime = 0; } catch (err) { /* noop */ }
        });
        document.body.classList.remove('ls-modal-open');
        if (lastTriggerButton && typeof lastTriggerButton.focus === 'function') {
          lastTriggerButton.focus();
        }
        lastTriggerButton = null;
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-lost-scenarios]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-lost-scenarios]');
    if (section) initSection(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-reveal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const sections = document.querySelectorAll('.scroll-reveal[data-section-id]');
    if (!sections.length) return;

    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // ===== Mobile per-beat video autoplay-on-view =====
    // When loop is disabled, we reset the video to time 0 on re-entry so it
    // replays from the start each time the user scrolls back to it. This is
    // intentional — feels like the video is "performing" each visit.
    function initBeatVideos() {
      const beatVideos = document.querySelectorAll('[data-beat-video]');
      if (!beatVideos.length) return;

      // Read loop setting from the parent section (default true if not set)
      function getLoopSetting(video) {
        const section = video.closest('.scroll-reveal');
        if (!section) return true;
        return section.dataset.mobileLoop !== 'false';
      }

      if (!('IntersectionObserver' in window)) {
        // Old browsers: just autoplay everything
        beatVideos.forEach(function (v) {
          try { v.play().catch(function () {}); } catch (e) {}
        });
        return;
      }

      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          const video = entry.target;
          const shouldLoop = getLoopSetting(video);
          if (entry.isIntersecting) {
            if (video.readyState === 0) {
              try { video.load(); } catch (e) {}
            }
            // If loop is disabled, reset to start each time we enter the viewport.
            // This gives the user a "fresh performance" instead of a frozen last frame.
            if (!shouldLoop) {
              try { video.currentTime = 0; } catch (e) {}
            }
            video.play().catch(function () {
              // Autoplay blocked — poster image (if any) is still visible
            });
          } else {
            try { video.pause(); } catch (e) {}
          }
        });
      }, {
        rootMargin: '50px 0px 50px 0px',
        threshold: 0.35
      });

      beatVideos.forEach(function (v) { observer.observe(v); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initBeatVideos);
    } else {
      initBeatVideos();
    }

    if (isMobile || prefersReducedMotion) return;

    // ===== GSAP loader (idempotent) =====
    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        if (document.querySelector('script[src="' + src + '"]')) {
          resolve();
          return;
        }
        const s = document.createElement('script');
        s.src = src;
        s.async = true;
        s.onload = resolve;
        s.onerror = reject;
        document.head.appendChild(s);
      });
    }

    async function ensureGsap() {
      if (window.gsap && window.ScrollTrigger) return;
      if (!window.gsap) {
        await loadScript('https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js');
      }
      if (!window.ScrollTrigger) {
        await loadScript('https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js');
      }
      window.gsap.registerPlugin(window.ScrollTrigger);
    }

    function initSection(section) {
      const video = section.querySelector('[data-scroll-video]');
      const beats = Array.from(section.querySelectorAll('.scroll-reveal__beat'));
      const railItems = Array.from(section.querySelectorAll('.scroll-reveal__rail-item'));
      const cue = section.querySelector('[data-scroll-cue]');
      const progress = section.querySelector('[data-scroll-progress]');
      const progressBar = progress ? progress.querySelector('.scroll-reveal__progress-bar') : null;
      const pinWrapper = section.querySelector('.scroll-reveal__pin-wrapper');

      if (!video || !pinWrapper) return;

      const CHAPTER_FOR_BEAT_INDEX = { 1: 1, 2: 2, 3: 3, 4: 3, 5: 3 };

      const gsap = window.gsap;
      const ScrollTrigger = window.ScrollTrigger;

      function detectHeaderHeight() {
        const headerSelectors = [
          'sticky-header',
          '.header-wrapper.header-wrapper--sticky',
          '.shopify-section-header-sticky',
          '.shopify-section-group-header-group',
          '.header-wrapper',
          'header.header',
          'header'
        ];
        for (let i = 0; i < headerSelectors.length; i++) {
          const el = document.querySelector(headerSelectors[i]);
          if (el) {
            const rect = el.getBoundingClientRect();
            const cs = getComputedStyle(el);
            if (rect.height > 0 && (cs.position === 'sticky' || cs.position === 'fixed')) {
              return Math.round(rect.height);
            }
          }
        }
        const fallback = parseInt(section.dataset.headerOffset, 10);
        return isNaN(fallback) ? 0 : fallback;
      }

      function applyHeaderOffset() {
        const h = detectHeaderHeight();
        section.style.setProperty('--sr-header-offset', h + 'px');
      }

      applyHeaderOffset();
      window.addEventListener('resize', applyHeaderOffset);

      function setupScroll() {
        const duration = video.duration;
        if (!duration || !isFinite(duration)) {
          return;
        }

        function readBeatSplits() {
          const raw = section.dataset.beatSplits;
          if (!raw) return [0.20, 0.40, 0.60, 0.80];
          const parts = raw.split(',').map(function (p) {
            const n = parseFloat(p);
            return isNaN(n) ? null : n / 100;
          }).filter(function (n) { return n !== null && n > 0 && n < 1; });
          if (parts.length !== 4) return [0.20, 0.40, 0.60, 0.80];
          for (let i = 1; i < parts.length; i++) {
            if (parts[i] <= parts[i - 1]) return [0.20, 0.40, 0.60, 0.80];
          }
          return parts;
        }

        function readBeat1StartOffset() {
          const raw = section.dataset.beat1StartOffset;
          const n = parseFloat(raw);
          if (isNaN(n) || n < 0) return 0;
          if (n > 50) return 50;
          return n / 100;
        }

        const splits = readBeatSplits();
        const beat1Start = readBeat1StartOffset();
        const beatRanges = [
          { from: beat1Start, to: splits[0] },
          { from: splits[0],  to: splits[1] },
          { from: splits[1],  to: splits[2] },
          { from: splits[2],  to: splits[3] },
          { from: splits[3],  to: 1.00 }
        ];

        function readNumber(name, fallback, min, max) {
          const raw = section.dataset[name];
          const n = parseFloat(raw);
          if (isNaN(n)) return fallback;
          if (n < min) return min;
          if (n > max) return max;
          return n;
        }

        const scrubSmoothing = readNumber('scrubSmoothing', 3, 0, 10) / 10;
        const videoStartOffset = readNumber('videoStartOffset', 0, 0, 25) / 100;
        const videoEndOffset = readNumber('videoEndOffset', 0, 0, 25) / 100;
        const videoStartTime = duration * videoStartOffset;
        const videoEndTime = duration * (1 - videoEndOffset);
        const videoPlayableDuration = Math.max(0.1, videoEndTime - videoStartTime);

        const headerOffset = detectHeaderHeight();

        const trigger = ScrollTrigger.create({
          trigger: pinWrapper,
          start: 'top ' + headerOffset + 'px',
          end: 'bottom bottom',
          scrub: scrubSmoothing,
          onUpdate: function (self) {
            const progressRatio = self.progress;

            const targetTime = videoStartTime + (progressRatio * videoPlayableDuration);
            if (Math.abs(video.currentTime - targetTime) > 0.02) {
              video.currentTime = targetTime;
            }

            if (progressBar) {
              progressBar.style.width = (progressRatio * 100).toFixed(2) + '%';
            }

            let activeBeatIndex = -1;

            beats.forEach(function (beat, i) {
              const range = beatRanges[i];
              if (!range) return;
              if (progressRatio < beat1Start) {
                beat.setAttribute('data-active', 'false');
                return;
              }
              const active = progressRatio >= range.from && progressRatio < range.to;
              const isLast = i === beats.length - 1;
              const finalActive = isLast ? progressRatio >= range.from : active;
              beat.setAttribute('data-active', finalActive ? 'true' : 'false');
              if (finalActive) {
                activeBeatIndex = i;
              }
            });

            if (railItems.length) {
              let activeChapter = 0;
              if (activeBeatIndex >= 0 && beats[activeBeatIndex]) {
                const beatIdx = parseInt(beats[activeBeatIndex].dataset.beatIndex, 10);
                activeChapter = CHAPTER_FOR_BEAT_INDEX[beatIdx] || 0;
              }
              railItems.forEach(function (item) {
                const chapterNum = parseInt(item.dataset.chapter, 10);
                item.setAttribute('data-active', chapterNum === activeChapter ? 'true' : 'false');
              });
            }

            if (cue) {
              cue.setAttribute('data-visible', progressRatio < 0.05 ? 'true' : 'false');
            }
            if (progress) {
              progress.setAttribute('data-visible', progressRatio > 0.01 && progressRatio < 0.99 ? 'true' : 'false');
            }
          },
          onEnter: function () {
            if (cue) cue.setAttribute('data-visible', 'true');
            beats.forEach(function (beat, i) {
              const shouldShowBeat1 = i === 0 && beat1Start === 0;
              beat.setAttribute('data-active', shouldShowBeat1 ? 'true' : 'false');
            });
            if (railItems.length) {
              railItems.forEach(function (item) {
                const chapterNum = parseInt(item.dataset.chapter, 10);
                const shouldActivate = chapterNum === 1 && beat1Start === 0;
                item.setAttribute('data-active', shouldActivate ? 'true' : 'false');
              });
            }
          },
          onLeaveBack: function () {
            if (cue) cue.setAttribute('data-visible', 'false');
          }
        });

        const CHAPTER_START_PROGRESS = {
          1: beat1Start,
          2: splits[0],
          3: splits[1]
        };

        railItems.forEach(function (item) {
          item.addEventListener('click', function () {
            const chapterNum = parseInt(item.dataset.chapter, 10);
            const startProgress = CHAPTER_START_PROGRESS[chapterNum];
            if (typeof startProgress !== 'number') return;

            const targetProgress = Math.min(startProgress + 0.005, 0.999);
            const targetScroll = trigger.start + (trigger.end - trigger.start) * targetProgress;

            window.scrollTo({
              top: targetScroll,
              behavior: 'smooth'
            });
          });
        });

        try {
          video.currentTime = videoStartTime;
        } catch (e) {}

        let resizeTimer;
        window.addEventListener('resize', function () {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function () {
            ScrollTrigger.refresh();
          }, 200);
        });
      }

      if (video.readyState >= 1) {
        setupScroll();
      } else {
        video.addEventListener('loadedmetadata', setupScroll, { once: true });
        video.addEventListener('canplay', setupScroll, { once: true });
      }

      video.play().then(function () {
        video.pause();
      }).catch(function () {
        const unlock = function () {
          video.play().then(function () { video.pause(); }).catch(function () {});
          document.removeEventListener('touchstart', unlock);
          document.removeEventListener('click', unlock);
        };
        document.addEventListener('touchstart', unlock, { once: true, passive: true });
        document.addEventListener('click', unlock, { once: true });
      });
    }

    ensureGsap().then(function () {
      sections.forEach(initSection);
    }).catch(function (err) {
      console.warn('[scroll-reveal] GSAP failed to load, falling back.', err);
      sections.forEach(function (s) {
        const pin = s.querySelector('.scroll-reveal__pin-wrapper');
        const mob = s.querySelector('.scroll-reveal__mobile');
        if (pin) pin.style.display = 'none';
        if (mob) mob.style.display = 'block';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
